module.exports = __webpack_public_path__ + "static/img/-2_29.5759b92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue2/-2_29.jpg
// module id = 3vdr
// module chunks = 7